module.exports = __webpack_public_path__ + "img/popup-bg.3c6878b9.svg";